export default "__VITE_ASSET__5b4d9a82__"